import { getToken } from './session';

/** EventSource cannot set headers. Angular puts bearer, tenant, and workspace on the query string. */
export async function sseUrl(
  path: string,
  extra?: Record<string, string | null | undefined>,
): Promise<string> {
  const token = await getToken();
  const tenantId = localStorage.getItem('orqforge.tenantId');
  const params = new URLSearchParams();
  if (token) params.set('token', token);
  if (tenantId) params.set('tenantId', tenantId);
  if (extra) {
    for (const [key, value] of Object.entries(extra)) {
      if (value) params.set(key, value);
    }
  }
  const qs = params.toString();
  return `${path}${qs ? `?${qs}` : ''}`;
}
